import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getUserProducts = createAsyncThunk(
    'userShop/getUserProducts',
    async () => {
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/products/get-user-products`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result;
        } else {
            const error = await response.json();
            throw new Error(error);
        }
    }
)

const userShopSlice = createSlice({
    name: 'userShop',
    initialState: {
        isLoading: false,
        error: null,
        data: null,
        isNeedRefresh: false
    },
    reducers: {
        setIsNeedRefresh: (state, action) => {
            state.isNeedRefresh = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserProducts.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getUserProducts.fulfilled, (state, action) => {
                state.data = action.payload.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getUserProducts.rejected, (state, action) => {
                state.error = action.error;
                state.data = null;
                state.isLoading = false;
            })
    }
})

export const { setIsNeedRefresh } = userShopSlice.actions;
export default userShopSlice.reducer;